import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TFWPIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M2.34965 9.80576V15.2H3.51688V9.80576H5.59994V8.80005H0.266602V9.80576H2.34965Z'
                fill='currentColor'
            />
            <Path
                d='M7.44812 12.5733H9.97237V11.5128H7.44812V9.86509H10.288V8.80005H6.13327V15.1806H7.44812V12.5733Z'
                fill='currentColor'
            />
            <Path
                d='M16.8787 8.80005L16.0201 13.34L16.0193 13.3407L14.9722 8.8008H13.8593L12.8078 13.331L11.9446 8.80005H10.6343L12.0494 15.1806H13.3732L14.4113 10.9122L15.4502 15.1806H16.774L18.1891 8.80005H16.8787Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M20.2137 15.1806V12.9323H21.3663C22.1232 12.9323 22.7155 12.7521 23.1433 12.3916C23.5711 12.0303 23.7858 11.5375 23.7858 10.9122C23.7858 10.5001 23.6878 10.1329 23.4919 9.8105C23.2959 9.48739 23.0162 9.23833 22.6519 9.06257C22.2892 8.88756 21.8674 8.80005 21.3879 8.80005H18.8989V15.1806H20.2137ZM21.3879 11.8673H20.2145V9.86509H21.4186C21.7432 9.87108 21.9975 9.9698 22.1815 10.1628C22.3655 10.3557 22.4575 10.6085 22.4575 10.9212C22.4575 11.2248 22.3662 11.4582 22.1837 11.622C22.0012 11.785 21.7357 11.8673 21.3879 11.8673Z'
                fill='currentColor'
            />
        </>
    ),
})

TFWPIcon.displayName = 'TFWPIcon'
